import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>Photo Gallary</h1>
      <h2>Your Pictures</h2>
      <p>Upload the image only in png or jpeg format.</p>
    </div>
  )
}

export default Title;